/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */
import './userName.scss';
import React , {Component  } from 'react';
import If from '../../../components/if';
import UserMedalIcon from '../userMedalIcon/userMedalIcon';
import { classSet } from '../../../utils/dom';
import IUserMedalInfo from '../../../../interface/userMedal';

export interface IProps {
    className: string;
    name: string;
    userLevelInfo?: number;
    userMedalInfo?: IUserMedalInfo;
    showUserLevel?: number;
    userMedalWidth?: 20 | 30 | 16;
    transcate?: boolean;
}

export default class UserName extends Component<IProps> {
    public render() {
        const { name, className, showUserLevel, userMedalInfo, userMedalWidth = 20, transcate } = this.props;
        const userMedalHolderWidth = userMedalWidth ? ' width-' + userMedalWidth : '';
        const transcateCls = (transcate && showUserLevel && userMedalInfo ? ('transcate' + userMedalHolderWidth) : 'transcate1');
        return (
            <div className={classSet('user-name-info is-mobile', className, transcateCls, Boolean(!showUserLevel) ? 'hidden-level' : '')}>
                <span className="user-name-content">{name}</span>
                <If condition={!!showUserLevel && !!userMedalInfo && !!userMedalInfo.medal_type}>
                    <div className={'user-medal-info-holder' + userMedalHolderWidth}>
                        <UserMedalIcon userMedalInfo={userMedalInfo!} userMedalWidth={userMedalWidth} />
                    </div>
                </If>
            </div>
        );
    }
}
